/* jshint node:true */
'use strict';
var React = require('react');
var Router = require('react-router');
var ESPNhelpersMixin = require('../../mixins/ESPNhelpersMixin');

var Home = React.createClass({
    displayName: 'Home',
    mixins: [
        Router.State, ESPNhelpersMixin
    ],
    getInitialState: function () {
        return {};
    },
    onChange: function () {},
    render: function () {
        return (
            <div>
                <p>Welcome to the awesome rugby site!</p>
            </div>
        );
    }
});

module.exports = Home;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/handlers/Home.jsx
 **/